import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setOfferId, setLeadId ,setIdForLeadPopup, setLeadStore, setSimulatorData} from './../app-context/policyProduction';
import { RiderPackageModel, VehicleDataModel } from '../models/superbit-api-models';
import { SimulatorModel } from '../models/SimulatorModel';


type Props = {
    leadId?: string;
    onClick?: Function;
    offer: any;
    riders: any;
    getSimulatorData: any;
    // newLeadAction: () => void;
};

const NewLeadAndProduction:React.FC<Props> = (props) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();


    const gotoLeads = () => {
        
        var newLead = "0"; 
        dispatch(setIdForLeadPopup(newLead))
        dispatch(setLeadStore(props.offer.lead))
        navigate('/Leads');
        
    }
    const onClickFunc = (e: any) => {
        console.log('saveOfferBtn clicked');
        if (props.offer != null) {
            var data = props.getSimulatorData();
            // 
            var riders = props.riders.filter((x: any) => x.autoActive == 0).map((x: any) => x.id);
            data.riders = data.riders.filter((item: RiderPackageModel) => riders.includes(item.id));
            var offer = props.offer;
            data.recalcOffer = offer;
            data.vehicle = new VehicleDataModel();
            data.vehicle.vehicleSubModelId = data.vehicleSubModelId;
            // if (this.props.selectedLeadId && this.props.selectedLeadId !== '')
            //   data.lead = {
            //     id: this.props.selectedLeadId
            //   }
            // this.props.selectedLeadId
            console.log('onClickFunc-NewLeadAndProduction', data)
            dispatch(setSimulatorData(data));
            // await new SimulatorModel().saveSimulator(data);
            //await this.setState({saveButtonClicked:false});
         
      
        }

        // if (props.leadId) {
        //     console.log('saveOfferBtn clicked', props.leadId);
        //     localStorage.setItem('offeredLeadId', props.leadId)
        //     gotoLeads()
        // }
        // if(props.newLeadAction){
        //     props.newLeadAction()
        // }
        if (props.onClick) {
            gotoLeads()
            // props.onClick(e)
        }
    }
    return (
        <>
              <button onClick={(e: any) => onClickFunc(e)}
                  className="button white data-card-action"
              >
                  שמירה ויצירת ליד
              </button>
        </>
    )
}

export default NewLeadAndProduction